import Common from '../common/CommonPowerbook';

class TmplObjectItem {

    constructor() {
        this.comm = Common.instance;
    }


     make(_d){
         return `
<section class="object object-item">
    <header class="object__header">
        <img class="object__icon" src="${this.comm.staticImgURL}/powerbook/lineage/${_d.image}" alt="">
        <span class="object__name"><a class="item-grade--1" href="${this.comm.powerbookURL}/${_d.name}">${_d.name}</a></span>
    </header>
    <article class="object__attribute">
        <table>
            <tbody>
                <tr>
                    <th scope="col">사용효과</th>
                    <td>${_d.effect||'-'}</td>
                </tr>
                <tr>
                    <th scope="col">종류</th>
                    <td><a href="${this.comm.powerbookURL}/${_d.type}">${_d.type}</a></td>
                </tr>
                <tr>
                    <th scope="col">클래스</th>
                    <td>${(_d.class && _d.class.length)? _d.class.map( item => `<a href="${this.comm.powerbookURL}/${item}">${item}</a>` ).join(', '): ''}</td>
                </tr>
                <tr>
                    <th scope="col">무게</th>
                    <td>${_d.weight||'-'}</td>
                </tr>
                <tr>
                    <th scope="col">재질</th>
                    <td>${_d.material||'-'}</td>
                </tr>
                <tr>
                    <th scope="col">교환</th>
                    <td>${_d.trade?"가능":"불가능"}</td>
                </tr>
                <tr>
                    <th scope="col">설명</th>
                    <td>${_d.description||'-'}</td>
                </tr>
                ${_d.trade?`<tr><td colspan="2"><a href="${this.comm.marketPriceLink(_d.id)}" class="object__price">시세보기</a></td></tr>`:''}
            </tbody>
        </table>
    </article>
</section>`
     }


}


export default TmplObjectItem;




// WEBPACK FOOTER //
// ./lineage/TmplObjectItem.js